var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8058 12.5465V7.56277C17.8058 3.39802 14.2986 0 10 0C5.70144 0 2.18525 3.39802 2.18525 7.56277V12.5465C0.917266 12.9735 0 14.1584 0 15.5263C0 17.2602 1.45683 18.6804 3.2554 18.6804H6.80755V18.9069C6.80755 20.6147 8.23741 22 10 22C11.7626 22 13.1924 20.6147 13.1924 18.9069V18.6804H16.7446C18.5342 18.6804 20 17.2689 20 15.5263C19.991 14.1584 19.0737 12.9735 17.8058 12.5465ZM10 19.9873C9.3795 19.9873 8.8759 19.4994 8.8759 18.8982V18.6717H11.1241V18.8982C11.1241 19.4994 10.6205 19.9873 10 19.9873ZM16.7446 16.6677H11.8705H11.1241H8.8759H7.7518H3.2554C2.59892 16.6677 2.06835 16.1537 2.06835 15.5176C2.06835 14.8903 2.58993 14.3762 3.23741 14.3675L4.2536 14.3501V7.55406C4.2536 4.49584 6.83453 2.00396 10 2.00396C13.1655 2.00396 15.7374 4.49584 15.7374 7.56277V14.3588L16.7536 14.3762C17.4011 14.385 17.9227 14.899 17.9227 15.5263C17.9227 16.1537 17.3921 16.6677 16.7446 16.6677Z",
    fill: "#332256"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.4b04e2c2bc1d21b6dd7fd7ccad9c35d4.svg";
export { ForwardRef as ReactComponent };